import React from 'react'
import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Foundations'
import type { BetLoopProfile } from '@core/Areas/BetLoop/types'
import {
  navigateToProfileFollowersList,
  navigateToProfileFollowingList,
} from '@core/Areas/BetLoop/helpers/navigation'
import { formatStatValue } from '@core/Areas/BetLoop/helpers/stringFormat'

export const FollowStats: React.FC<
  { isMyProfile: boolean } & Pick<
    BetLoopProfile,
    'followerCount' | 'followingCount' | 'shareCount' | 'id'
  >
> = ({ isMyProfile, followerCount, followingCount, shareCount, id }) => {
  return (
    <WrapperStyled>
      <div
        data-testid='FollowStats.Followers'
        onClick={() => navigateToProfileFollowersList(id, isMyProfile)}
      >
        <span>{formatStatValue(followerCount || 0)}</span>
        <span>Followers</span>
      </div>

      <div
        data-testid='FollowStats.Following'
        onClick={() => navigateToProfileFollowingList(id, isMyProfile)}
      >
        <span>{formatStatValue(followingCount)}</span>
        <span>Following</span>
      </div>

      <div>
        <span>{formatStatValue(shareCount)}</span>
        <span>Shared Bets</span>
      </div>
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  margin: '0 auto',
  fontFamily: font.family.primary,
  textAlign: 'center',

  '> div': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `0 ${spacing.sm}`,

    '&:nth-of-type(2)': {
      borderRight: `1px solid ${colors.neutral[200]}`,
      borderLeft: `1px solid ${colors.neutral[200]}`,
    },

    '> span:first-of-type': {
      fontSize: font.size.xl2.fontSize,
      letterSpacing: font.size.xl2.letterSpacing,
      lineHeight: font.size.xl2.lineHeight,
      fontWeight: font.weight.semibold,
      color: colors.black,
    },

    '> span:last-of-type': {
      fontSize: font.size.md.fontSize,
      letterSpacing: font.size.md.letterSpacing,
      lineHeight: font.size.md.lineHeight,
      fontWeight: font.weight.regular,
      color: colors.neutral[700],
    },
  },
})
